module.exports = __webpack_public_path__ + "static/media/BS_F_Embroidery_Vela_Dark grey_White.2894e94d.png";